import { RouteComponentProps } from 'react-router-dom'

import { roundUpsScreenViewed } from 'pages/invest/core/roundUps/segment'
import { RecurringInvestmentScreenViewed } from 'pages/invest/later/segment'
import { linkedAccountsScreenViewedFields } from 'pages/settings/linked-accounts/segment'
import { requestCloseAccountScreenViewedFields } from 'pages/settings/my-subscription/segment'
import { routes } from 'router/routes'

// Mapped event data for Screen Viewed events

const fieldsMap = new Map<string, object>([
  // Top level pages

  [
    '/past',
    {
      object_name: 'past',
      screen: 'past',
      screenName: 'past',
      style: 'main',
    },
  ],

  [
    '/present',
    {
      object_name: 'present',
      screen: 'present',
      screenName: 'present',
      style: 'main',
    },
  ],

  // Settings

  [
    '/settings',
    {
      object_name: 'settings',
      screen: 'settings',
      screenName: 'settings',
      style: 'main',
    },
  ],

  [
    '/settings/personal',
    {
      object_name: 'personalInfo',
      screen: 'personalInfo',
      screenName: 'personalInfo',
    },
  ],

  [
    '/portfolio/investor-profile',
    {
      object_name: 'investorProfile',
      screen: 'investorProfile',
      screenName: 'investorProfile',
    },
  ],

  ['/settings/linked-accounts', linkedAccountsScreenViewedFields()],

  [
    '/settings/my-subscription',
    {
      object_name: 'myAccounts',
      screen: 'myAccounts',
      screen_name: 'myAccounts',
    },
  ],
  ['/cancel-subscription', requestCloseAccountScreenViewedFields()],
  [
    '/wv/my-subscription',
    {
      object_name: 'myAccounts',
      screen: 'myAccounts',
      screen_name: 'myAccounts',
    },
  ],
  ['/wv/cancel-subscription', requestCloseAccountScreenViewedFields()],
  ['/wv/close-account', requestCloseAccountScreenViewedFields()],

  // Spend
  [
    '/spend',
    {
      object_name: 'spend',
      screen: 'spend',
      screenName: 'spend',
      style: 'default',
    },
  ],
  [
    '/spend/signup/verify',
    {
      object_name: 'spendVerificationChecklist',
      screen: 'spendVerificationChecklist',
      screen_name: 'spendVerificationChecklist',
    },
  ],

  [
    '/spend/signup/verify/identity',
    {
      object_name: 'spendVerificationInterstitial',
      screen: 'spendVerificationInterstitial',
      screen_name: 'spendVerificationInterstitial',
      verification_type: 'identity',
    },
  ],

  [
    '/spend/signup/verify/address',
    {
      object_name: 'spendVerificationInterstitial',
      screen: 'spendVerificationInterstitial',
      screen_name: 'spendVerificationInterstitial',
      verification_type: 'address',
    },
  ],

  [
    '/spend/transfer',
    {
      object_name: 'spendTransfer',
      screen_name: 'spendTransfer',
      screen: 'spendTransfer',
    },
  ],

  [
    '/spend/recurring',
    {
      object_name: 'spendRecurringSettings',
      screen: 'spendRecurringSettings',
      screen_name: 'spendRecurringSettings',
    },
  ],

  [
    '/settings/spend',
    {
      object_name: 'debitCardScreen',
      screen_name: 'debitCardScreen',
      screen: 'debitCardScreen',
    },
  ],
  [
    '/settings/close-account/spend',
    {
      object_name: 'closeAccountSpend',
      screen_name: 'closeAccountSpend',
      screen: 'closeAccountSpend',
    },
  ],

  // Core pages

  [
    '/invest/core',
    {
      object_name: 'core',
      screen: 'core',
      screenName: 'core',
      style: 'main',
    },
  ],

  [
    '/invest/core/recurring',
    {
      object_name: 'recurringScreen',
      screen: 'core',
      screenName: 'core',
      style: 'default',
    },
  ],

  [
    '/invest/core/one-time',
    {
      object_name: 'oneTimeScreen',
      screen: 'core',
      screenName: 'core',
      style: 'text',
    },
  ],

  [
    '/invest/core/round-ups/settings',
    {
      object_name: 'roundUpScreen',
      screen: 'core',
      screenName: 'core',
      style: 'default',
    },
  ],

  ['/invest/core/round-ups', roundUpsScreenViewed()],

  // Later pages

  [
    '/invest/later',
    {
      object_name: 'later',
      screen: 'later',
      screen_name: 'later',
      style: 'main',
    },
  ],
  [
    '/invest/later/withdraw',
    {
      object_name: 'requestLaterWithdrawal',
      screen: 'laterRequestWithdraw',
      screen_name: 'laterRequestWithdraw',
      style: 'main',
    },
  ],
  [
    '/invest/later/withdraw-reason',
    {
      object_name: 'laterWithdrawalReason',
      screen: 'laterWithdrawalReason',
      screen_name: 'laterWithdrawalReason',
      style: 'main',
    },
  ],
  [
    '/invest/later/withdraw-amount',
    {
      object_name: 'laterWithdraw',
      screen: 'laterWithdraw',
      screen_name: 'laterWithdraw',
      style: 'main',
    },
  ],
  [
    '/invest/later/over-contribution',
    {
      object_name: 'laterWithdrawOverContributed',
      screen: 'laterWithdrawOverContributed',
      screen_name: 'laterWithdrawOverContributed',
      style: 'main',
    },
  ],

  [
    '/invest/later/signup',
    {
      object_name: 'laterRegistrationInterstitial',
      screen: 'later',
      screen_name: 'later',
      style: 'default',
    },
  ],

  ['/invest/later/recurring', RecurringInvestmentScreenViewed()],

  // Earn pages

  [
    '/earn/found-money',
    {
      object_name: 'foundMoney',
      screen: 'foundMoney',
      screenName: 'foundMoney',
      style: 'main',
    },
  ],

  // Direct Deposit

  [
    '/spend/direct-deposit',
    {
      object_name: 'directDepositSearch',
      screen: 'directDepositSearch',
      screen_name: 'directDepositSearch',
    },
  ],
  [
    '/spend/direct-deposit/pdf',
    {
      object_name: 'directDepositPDF',
      screen: 'directDepositPDF',
      screen_name: 'directDepositPDF',
    },
  ],
  [
    '/spend/direct-deposit/online',
    {
      object_name: 'directDepositOnline',
      screen: 'directDepositOnline',
      screen_name: 'directDepositOnline',
    },
  ],
  [
    '/spend/direct-deposit/submittable',
    {
      object_name: 'directDepositSubmittableEmployerInfo',
      screen: 'directDepositSubmittableEmployerInfo',
      screen_name: 'directDepositSubmittableEmployerInfo',
    },
  ],
  [
    '/wv/spend/direct-deposit/search',
    {
      object_name: 'directDepositSearch',
      screen: 'directDepositSearch',
      screen_name: 'directDepositSearch',
    },
  ],
  [
    '/wv/spend/direct-deposit/pdf',
    {
      object_name: 'directDepositPDF',
      screen: 'directDepositPDF',
      screen_name: 'directDepositPDF',
    },
  ],
  [
    '/wv/spend/direct-deposit/online',
    {
      object_name: 'directDepositOnline',
      screen: 'directDepositOnline',
      screen_name: 'directDepositOnline',
    },
  ],
  [
    '/wv/spend/direct-deposit/submittable',
    {
      object_name: 'directDepositSubmittableEmployerInfo',
      screen: 'directDepositSubmittableEmployerInfo',
      screen_name: 'directDepositSubmittableEmployerInfo',
    },
  ],

  // Grow pages

  [
    '/grow',
    {
      object_name: 'grow',
      screen: 'grow',
      screen_name: 'grow',
    },
  ],

  // Early
  [
    routes.early.index,
    {
      object_name: 'early',
      screen: 'early',
      screen_name: 'early',
    },
  ],
  // Close Account Revamp Pages

  // Later
  [
    'settings/close-account/later',
    {
      object_name: 'closeAccountLater',
      screen: 'closeAccountLater',
      screen_name: 'closeAccountLater',
    },
  ],
  [
    'wv/later/close-account',
    {
      object_name: 'closeAccountLater',
      screen: 'closeAccountLater',
      screen_name: 'closeAccountLater',
    },
  ],
])

export default (location: RouteComponentProps<{}>['location']) => {
  const fields = fieldsMap.get(location.pathname) || {}

  return {
    event: 'screen_viewed',
    hash: location.hash,
    path: location.pathname,
    search: location.search,
    title: document.title,
    object_name: 'automaticPageTracking',
    ...fields,
  }
}
